import React from 'react';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import {
  GatsbyImage,
  getImage,
} from 'gatsby-plugin-image';

// Triptychs are triggered by a gallery of three images in the arc file. The description
// of the gallery serves as the single caption for both images. If photo/copy dictates
// that the caption containes left/top/right/bottom identifiers within the caption,
// span tags may need to be added around these within the caption, and then display
// properties set for each depending on screen size

const TriptychWrapper = styled.div`
  max-width: var(--content-max-width);
  margin: 2rem auto;
  padding: 0 20px;
`;

const ImagesContainer = styled.div`
  &:after {
    content: '';
    display: table;
    clear: both;
  }
  .triptych__image:nth-of-type(1) {
    margin-bottom: 1rem;
    width: 100%;
  }
  .triptych__image:nth-of-type(2) {
    width: calc(50% - 0.5rem);
    float: left;
  }
  .triptych__image:nth-of-type(3) {
    width: calc(50% - 0.5rem);
    float: right;
  }
`;

const TriptychCaption = styled.p`
  max-width: var(--content-max-width);
  width: 100%;
  margin: 0.5rem auto 0;
  font-size: 0.875rem;
  line-height: 1.125rem;
`;

const Triptych = (({ description, images }) => (
  <TriptychWrapper>
    <ImagesContainer>
      {images.map((image) => (
        <GatsbyImage className="triptych__image" alt={image.caption} image={getImage(image.localImage)} key={image._id} />
      ))}
    </ImagesContainer>
    <TriptychCaption className="benton-n4">{ReactHtmlParser(description.basic)}</TriptychCaption>
  </TriptychWrapper>
));

export default Triptych;

Triptych.propTypes = {
  description: PropTypes.shape({
    basic: PropTypes.string,
  }).isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      localImage: PropTypes.shape({}),
      caption: PropTypes.string,
      _id: PropTypes.string,
    }),
  ).isRequired,
};
